import UAEFlag from '../assets/images/UAE.svg';
import UKFlag from '../assets/images/Mask-group.svg';
import SaudiFlag from '../assets/images/Saudi_Arabia.svg';
import globeIcon from "../assets/images/Globe.svg";

export const COUNTRY_DATA = [
  {code: '', svgPath: ''},
  { code: '+971', svgPath: UAEFlag },
  { code: '+1', svgPath: globeIcon },
  { code: '+44', svgPath: UKFlag },
  { code: '+61', svgPath: globeIcon},
  { code: '+91', svgPath: globeIcon },
  { code: '+49', svgPath: globeIcon },
  { code: '+966', svgPath: SaudiFlag },
  { code: '+353', svgPath: globeIcon },
  { code: '+33', svgPath: globeIcon },
  { code: '+93', svgPath: globeIcon },
  { code: '+355', svgPath: globeIcon },
  { code: '+213', svgPath: globeIcon },
  { code: '+1684', svgPath: globeIcon },
  { code: '+376', svgPath: globeIcon },
  { code: '+244', svgPath: globeIcon },
  { code: '+1264', svgPath: globeIcon },
  { code: '+1268', svgPath: globeIcon },
  { code: '+54', svgPath: globeIcon },
  { code: '+374', svgPath: globeIcon },
  { code: '+297', svgPath: globeIcon },
  { code: '+43', svgPath: globeIcon },
  { code: '+994', svgPath: globeIcon },
  { code: '+1242', svgPath: globeIcon },
  { code: '+973', svgPath: globeIcon },
  { code: '+880', svgPath: globeIcon },
  { code: '+1246', svgPath: globeIcon },
  { code: '+375', svgPath: globeIcon },
  { code: '+32', svgPath: globeIcon },
  { code: '+501', svgPath: globeIcon },
  { code: '+229', svgPath: globeIcon },
  { code: '+1441', svgPath: globeIcon },
  { code: '+975', svgPath: globeIcon },
  { code: '+591', svgPath: globeIcon },
  { code: '+387', svgPath: globeIcon },
  { code: '+267', svgPath: globeIcon },
  { code: '+55', svgPath: globeIcon },
  { code: '+246', svgPath: globeIcon },
  { code: '+673', svgPath: globeIcon },
  { code: '+359', svgPath: globeIcon },
  { code: '+226', svgPath: globeIcon },
  { code: '+257', svgPath: globeIcon },
  { code: '+855', svgPath: globeIcon },
  { code: '+237', svgPath: globeIcon },
  { code: '+238', svgPath: globeIcon },
  { code: '+1345', svgPath: globeIcon },
  { code: '+236', svgPath: globeIcon },
  { code: '+235', svgPath: globeIcon },
  { code: '+56', svgPath: globeIcon },
  { code: '+86', svgPath: globeIcon },
  { code: '+57', svgPath: globeIcon },
  { code: '+269', svgPath: globeIcon },
  { code: '+242', svgPath: globeIcon },
  { code: '+243', svgPath: globeIcon },
  { code: '+682', svgPath: globeIcon },
  { code: '+506', svgPath: globeIcon },
  { code: '+385', svgPath: globeIcon },
  { code: '+53', svgPath: globeIcon },
  { code: '+357', svgPath: globeIcon },
  { code: '+420', svgPath: globeIcon },
  { code: '+225', svgPath: globeIcon },
  { code: '+45', svgPath: globeIcon },
  { code: '+253', svgPath: globeIcon },
  { code: '+1767', svgPath: globeIcon },
  { code: '+1849', svgPath: globeIcon },
  { code: '+1829', svgPath: globeIcon },
  { code: '+1809', svgPath: globeIcon },
  { code: '+593', svgPath: globeIcon },
  { code: '+20', svgPath: globeIcon },
  { code: '+503', svgPath: globeIcon },
  { code: '+240', svgPath: globeIcon },
  { code: '+291', svgPath: globeIcon },
  { code: '+372', svgPath: globeIcon },
  { code: '+251', svgPath: globeIcon },
  { code: '+298', svgPath: globeIcon },
  { code: '+679', svgPath: globeIcon },
  { code: '+594', svgPath: globeIcon },
  { code: '+689', svgPath: globeIcon },
  { code: '+241', svgPath: globeIcon },
  { code: '+220', svgPath: globeIcon },
  { code: '+995', svgPath: globeIcon },
  { code: '+233', svgPath: globeIcon },
  { code: '+350', svgPath: globeIcon },
  { code: '+30', svgPath: globeIcon },
  { code: '+299', svgPath: globeIcon },
  { code: '+1473', svgPath: globeIcon },
  { code: '+1671', svgPath: globeIcon },
  { code: '+502', svgPath: globeIcon },
  { code: '+224', svgPath: globeIcon },
  { code: '+245', svgPath: globeIcon },
  { code: '+592', svgPath: globeIcon },
  { code: '+509', svgPath: globeIcon },
  { code: '+379', svgPath: globeIcon },
  { code: '+504', svgPath: globeIcon },
  { code: '+852', svgPath: globeIcon },
  { code: '+36', svgPath: globeIcon },
  { code: '+354', svgPath: globeIcon },
  { code: '+62', svgPath: globeIcon },
  { code: '+98', svgPath: globeIcon },
  { code: '+964', svgPath: globeIcon },
  { code: '+972', svgPath: globeIcon },
  { code: '+39', svgPath: globeIcon },
  { code: '+1876', svgPath: globeIcon },
  { code: '+81', svgPath: globeIcon },
  { code: '+962', svgPath: globeIcon },
  { code: '+254', svgPath: globeIcon },
  { code: '+686', svgPath: globeIcon },
  { code: '+850', svgPath: globeIcon },
  { code: '+82', svgPath: globeIcon },
  { code: '+383', svgPath: globeIcon },
  { code: '+965', svgPath: globeIcon },
  { code: '+996', svgPath: globeIcon },
  { code: '+856', svgPath: globeIcon },
  { code: '+371', svgPath: globeIcon },
  { code: '+961', svgPath: globeIcon },
  { code: '+266', svgPath: globeIcon },
  { code: '+231', svgPath: globeIcon },
  { code: '+218', svgPath: globeIcon },
  { code: '+423', svgPath: globeIcon },
  { code: '+370', svgPath: globeIcon },
  { code: '+352', svgPath: globeIcon },
  { code: '+853', svgPath: globeIcon },
  { code: '+389', svgPath: globeIcon },
  { code: '+261', svgPath: globeIcon },
  { code: '+265', svgPath: globeIcon },
  { code: '+60', svgPath: globeIcon },
  { code: '+960', svgPath: globeIcon },
  { code: '+223', svgPath: globeIcon },
  { code: '+356', svgPath: globeIcon },
  { code: '+692', svgPath: globeIcon },
  { code: '+596', svgPath: globeIcon },
  { code: '+222', svgPath: globeIcon },
  { code: '+230', svgPath: globeIcon },
  { code: '+52', svgPath: globeIcon },
  { code: '+691', svgPath: globeIcon },
  { code: '+373', svgPath: globeIcon },
  { code: '+377', svgPath: globeIcon },
  { code: '+976', svgPath: globeIcon },
  { code: '+382', svgPath: globeIcon },
  { code: '+1664', svgPath: globeIcon },
  { code: '+258', svgPath: globeIcon },
  { code: '+95', svgPath: globeIcon },
  { code: '+264', svgPath: globeIcon },
  { code: '+674', svgPath: globeIcon },
  { code: '+977', svgPath: globeIcon },
  { code: '+31', svgPath: globeIcon },
  { code: '+687', svgPath: globeIcon },
  { code: '+505', svgPath: globeIcon },
  { code: '+227', svgPath: globeIcon },
  { code: '+234', svgPath: globeIcon },
  { code: '+683', svgPath: globeIcon },
  { code: '+672', svgPath: globeIcon },
  { code: '+1670', svgPath: globeIcon },
  { code: '+968', svgPath: globeIcon },
  { code: '+92', svgPath: globeIcon },
  { code: '+680', svgPath: globeIcon },
  { code: '+970', svgPath: globeIcon },
  { code: '+507', svgPath: globeIcon },
  { code: '+675', svgPath: globeIcon },
  { code: '+595', svgPath: globeIcon },
  { code: '+51', svgPath: globeIcon },
  { code: '+63', svgPath: globeIcon },
  { code: '+64', svgPath: globeIcon },
  { code: '+48', svgPath: globeIcon },
  { code: '+351', svgPath: globeIcon },
  { code: '+1939', svgPath: globeIcon },
  { code: '+1787', svgPath: globeIcon },
  { code: '+974', svgPath: globeIcon },
  { code: '+40', svgPath: globeIcon },
  { code: '+7', svgPath: globeIcon },
  { code: '+250', svgPath: globeIcon },
  { code: '+262', svgPath: globeIcon },
  { code: '+290', svgPath: globeIcon },
  { code: '+1869', svgPath: globeIcon },
  { code: '+1758', svgPath: globeIcon },
  { code: '+590', svgPath: globeIcon },
  { code: '+508', svgPath: globeIcon },
  { code: '+1784', svgPath: globeIcon },
  { code: '+685', svgPath: globeIcon },
  { code: '+378', svgPath: globeIcon },
  { code: '+239', svgPath: globeIcon },
  { code: '+221', svgPath: globeIcon },
  { code: '+381', svgPath: globeIcon },
  { code: '+248', svgPath: globeIcon },
  { code: '+232', svgPath: globeIcon },
  { code: '+65', svgPath: globeIcon },
  { code: '+1721', svgPath: globeIcon },
  { code: '+421', svgPath: globeIcon },
  { code: '+386', svgPath: globeIcon },
  { code: '+677', svgPath: globeIcon },
  { code: '+252', svgPath: globeIcon },
  { code: '+27', svgPath: globeIcon },
  { code: '+500', svgPath: globeIcon },
  { code: '+211', svgPath: globeIcon },
  { code: '+34', svgPath: globeIcon },
  { code: '+94', svgPath: globeIcon },
  { code: '+249', svgPath: globeIcon },
  { code: '+597', svgPath: globeIcon },
  { code: '+47', svgPath: globeIcon },
  { code: '+268', svgPath: globeIcon },
  { code: '+46', svgPath: globeIcon },
  { code: '+41', svgPath: globeIcon },
  { code: '+963', svgPath: globeIcon },
  { code: '+886', svgPath: globeIcon },
  { code: '+992', svgPath: globeIcon },
  { code: '+255', svgPath: globeIcon },
  { code: '+66', svgPath: globeIcon },
  { code: '+599', svgPath: globeIcon },
  { code: '+670', svgPath: globeIcon },
  { code: '+228', svgPath: globeIcon },
  { code: '+690', svgPath: globeIcon },
  { code: '+676', svgPath: globeIcon },
  { code: '+1868', svgPath: globeIcon },
  { code: '+216', svgPath: globeIcon },
  { code: '+90', svgPath: globeIcon },
  { code: '+993', svgPath: globeIcon },
  { code: '+1649', svgPath: globeIcon },
  { code: '+688', svgPath: globeIcon },
  { code: '+256', svgPath: globeIcon },
  { code: '+380', svgPath: globeIcon },
  { code: '+598', svgPath: globeIcon },
  { code: '+998', svgPath: globeIcon },
  { code: '+678', svgPath: globeIcon },
  { code: '+58', svgPath: globeIcon },
  { code: '+84', svgPath: globeIcon },
  { code: '+1284', svgPath: globeIcon },
  { code: '+1340', svgPath: globeIcon },
  { code: '+681', svgPath: globeIcon },
  { code: '+212', svgPath: globeIcon },
  { code: '+967', svgPath: globeIcon },
  { code: '+260', svgPath: globeIcon },
  { code: '+263', svgPath: globeIcon },
  { code: '+358', svgPath: globeIcon }
];

